/* Progressive enhancement only; credentials and customer data stay in Shopify forms. */
(() => {
  'use strict';
  function init() {
    document.querySelectorAll('.swa').forEach(root => {
      if (root.dataset.swaReady) return;
      root.dataset.swaReady = 'true';
      root.querySelectorAll('[data-swa-password]').forEach(button => {
        const input = document.getElementById(button.dataset.swaPassword);
        if (!input || !root.contains(input)) return;
        button.hidden = false;
        button.addEventListener('click', () => {
          const reveal = input.type === 'password';
          input.type = reveal ? 'text' : 'password';
          button.setAttribute('aria-pressed', String(reveal));
          button.textContent = reveal ? button.dataset.hide : button.dataset.show;
        });
      });
      root.querySelectorAll('[data-swa-confirm]').forEach(input => {
        const password = document.getElementById(input.dataset.swaConfirm);
        if (!password || !root.contains(password)) return;
        const validate = () => input.setCustomValidity(input.value && input.value !== password.value ? input.dataset.mismatch : '');
        input.addEventListener('input', validate);
        password.addEventListener('input', validate);
      });
      const result = root.querySelector('[data-swa-recovery-result]');
      if (result && window.location.hash !== '#login') root.classList.add('swa-recovery-result');
      const changePanel = () => {
        if (window.location.hash === '#login') root.classList.remove('swa-recovery-result');
        const panel = window.location.hash === '#recover' ? root.querySelector('#recover') : root.querySelector('#login');
        panel?.querySelector('h1')?.focus({preventScroll: true});
      };
      if (root.querySelector('#recover')) {
        window.addEventListener('hashchange', changePanel);
        // The base theme intercepts fragment links for smooth scrolling. These
        // fragments select forms, so handle them before the scrolling listener.
        root.addEventListener('click', event => {
          const link = event.target.closest('a[href="#recover"], a[href="#login"]');
          if (!link) return;
          event.preventDefault();
          event.stopPropagation();
          window.location.hash = link.getAttribute('href');
          changePanel();
        }, true);
      }
      // A rejected address must reopen so the customer can correct it.
      root.querySelectorAll('.address-form:has(.swa-errors)').forEach(form => form.classList.remove('hidden'));
      root.querySelector('.swa-errors, [data-swa-recovery-result]')?.focus({preventScroll: true});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
